import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import LocaleUtils from 'react-day-picker/moment';
import {isMobile} from 'core/utils';
import {Input} from 'components/forms';
import dayPickerStyles from './day-picker.css';
import styles from './styles.css';

@autobind
export default class DateInput extends Component {
    static propTypes = {
        placeholder: PropTypes.string,
        value: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        min: PropTypes.string,
        max: PropTypes.string,
    };

    static defaultProps = {
        placeholder: 'Seleccioná una fecha',
    };

    state = {
        focus: false,
    };

    componentDidMount() {
        document.body.addEventListener('click', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.handleOutsideClick);
    }

    getValueForDisplay() {
        return this.props.value && moment(this.props.value).format('LL');
    }

    getValueForDateInput(value) {
        return value ? moment(value).format('YYYY-MM-DD') : '';
    }

    getValueForDayPicker(value) {
        return value ? moment(value).toDate() : undefined;
    }

    getDayPickerInitialMonth() {
        const value = this.props.value && moment(this.props.value).toDate();
        const min = this.props.min && moment(this.props.min).toDate();
        return value || min || new Date();
    }

    setNodeRef(node) {
        this.node = node;
    }

    handleDayPickerChange(day) {
        this.setState({focus: false});
        this.props.onChange(moment(day).format('YYYY-MM-DD'));
        if (this.props.onBlur) this.props.onBlur();
    }

    handleDayPickerIsDisabled(day) {
        const min = this.props.min && moment(this.props.min);
        const max = this.props.max && moment(this.props.max);
        return (min && day < min) || (max && day > max);
    }

    handleInputChange(day) {
        return this.props.onChange(day);
    }

    handleClickOnContainer() {
        if (!this.state.focus) this.setState({focus: true});
    }

    handleOutsideClick(event) {
        if (this.node && !this.node.contains(event.target) && this.state.focus) {
            this.setState({focus: false});
            if (this.props.onBlur) this.props.onBlur();
        }
    }

    renderDayPickerNavbar(props) {
        const onPreviousClick = () => props.onPreviousClick();
        const onNextClick = () => props.onNextClick();
        return (
            <div className={dayPickerStyles.navBar}>
                <div className={dayPickerStyles.navButtonPrev} onClick={onPreviousClick}>
                    <i className='material-icons'>chevron_left</i>
                </div>
                <div className={dayPickerStyles.navButtonNext} onClick={onNextClick}>
                    <i className='material-icons'>chevron_right</i>
                </div>
            </div>
        );
    }

    renderInput() {
        return (
            <Input
                type='date'
                placeholder={this.props.placeholder}
                value={this.getValueForDateInput(this.props.value)}
                min={this.getValueForDateInput(this.props.min)}
                max={this.getValueForDateInput(this.props.max)}
                onChange={this.handleInputChange}
                onBlur={this.props.onBlur}
            />
        );
    }

    renderDayPicker() {
        return (
            <div ref={this.setNodeRef}>
                <div
                    className={classNames(styles.root, {[styles.focused]: this.state.focus})}
                    onClick={this.handleClickOnContainer}>
                    <div className={styles.display}>
                        {this.props.value
                            ? <span className={styles.value}>{this.getValueForDisplay()}</span>
                            : <span className={styles.placeholder}>{this.props.placeholder}</span>
                        }
                        <i className='material-icons'>date_range</i>
                    </div>
                </div>
                {this.state.focus && (
                    <DayPicker
                        autoFocus
                        classNames={dayPickerStyles}
                        selectedDays={this.props.value ? moment(this.props.value).toDate() : null}
                        initialMonth={this.getDayPickerInitialMonth()}
                        disabledDays={this.handleDayPickerIsDisabled}
                        navbarElement={this.renderDayPickerNavbar}
                        locale='es'
                        localeUtils={LocaleUtils}
                        onDayClick={this.handleDayPickerChange}
                    />
                )}
            </div>
        );
    }

    render() {
        if (isMobile()) return this.renderInput();
        return this.renderDayPicker();
    }
}



// WEBPACK FOOTER //
// ./components/forms/date-input/index.js